import CircularProgress from '@mui/material/CircularProgress'
import { PPDialog } from 'components/PPDialog'
import { useEffect, useMemo, useRef, useState } from 'react'
import { getImagesUrlsMap } from 'shared'
import styles from './PostFilesDialog.pcss'

const LOADER_SIZE = 40
export interface PostFilesDialogProps {
  active: boolean
  images: string[]
  onClose: () => void
}

export function PostFilesDialog(props: PostFilesDialogProps) {
  const urls = useMemo(() => getImagesUrlsMap(props.images), [props.images])
  const urlsRef = useRef(urls)
  const imagesRef = useRef(props.images)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (props.images.length > 0) {
      urlsRef.current = urls
      imagesRef.current = props.images
    }
  }, [props.images.length, urls, props.images])

  // EXPL: This is needed to keep the current images displayed while closing the dialog
  const visibleImages = useMemo(() => {
    return props.active ? urls : urlsRef.current
  }, [props.active, urls])

  // Create array of thumbnail URLs in the same order as original images
  const visibleImagesArray = useMemo(() => {
    const imagesToUse = props.active ? props.images : imagesRef.current
    const urlsMap = props.active ? urls : urlsRef.current
    
    // Find the thumbnail key for each original image URL
    return imagesToUse.map(originalUrl => {
      return Object.keys(urlsMap).find(thumbUrl => urlsMap[thumbUrl] === originalUrl) || originalUrl
    })
  }, [props.active, props.images, urls])

  const onError = (e: any) => {
    if (e.target.src !== visibleImages[e.target.src]) {
      e.target.src = visibleImages[e.target.src]
    }
    setLoading(false)
  }

  const stopLoading = () => {
    setLoading(false)
  }

  return (
    <PPDialog open={props.active} onClose={props.onClose} size="lg" title="Post images">
      <div className={styles.grid}>
        {visibleImagesArray.map((thumbUrl, index) => (
          <div className={styles['grid-item']} key={index}>
            {loading && <CircularProgress size={LOADER_SIZE} className={styles.loader} />}
            <img src={thumbUrl} className={styles.image} onError={onError} onLoad={stopLoading} />
          </div>
        ))}
      </div>
    </PPDialog>
  )
}

export default PostFilesDialog
